/**
 * @generated SignedSource<<33f20c1b2fbec386da6e35b3900b80b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HoleCount = "EIGHTEEN" | "NINE" | "NONE";
export type PatronBookingAffectedRateItemLineQuery$variables = {
  durationMins: number;
  holeCount: HoleCount;
  playerCount: number;
  rateId: string;
  slotTargetId: string;
  sourceBookingRateId: string;
  targetId: string;
};
export type PatronBookingAffectedRateItemLineQuery$data = {
  readonly newRate: {
    readonly __typename: string;
    readonly id: string;
    readonly name?: string;
  } | null | undefined;
  readonly sourceRoundOrBooking: {
    readonly __typename: string;
    readonly id: string;
    readonly player?: {
      readonly fullName: string;
    } | null | undefined;
    readonly rate?: {
      readonly appliesToMembershipType: boolean | null | undefined;
      readonly code: string;
      readonly name: string;
    } | null | undefined;
    readonly roundRate?: {
      readonly rate: {
        readonly name: string;
      };
      readonly totalDurationPrice: number | null | undefined;
      readonly totalGolfPrice: number | null | undefined;
    } | null | undefined;
    readonly startSlot?: {
      readonly id: string;
      readonly slotRate: {
        readonly totalDurationPrice: number | null | undefined;
        readonly totalGolfPrice: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly targetSlotForBookingPrice: {
    readonly __typename: "TimeSlot";
    readonly id: string;
    readonly slotRate: {
      readonly rate: {
        readonly name: string;
      };
      readonly totalDurationPrice: number | null | undefined;
      readonly totalGolfPrice: number | null | undefined;
    } | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type PatronBookingAffectedRateItemLineQuery = {
  response: PatronBookingAffectedRateItemLineQuery$data;
  variables: PatronBookingAffectedRateItemLineQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "durationMins"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "holeCount"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "playerCount"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rateId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slotTargetId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceBookingRateId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetId"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "rateId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = [
  (v10/*: any*/)
],
v12 = {
  "alias": "newRate",
  "args": (v7/*: any*/),
  "concreteType": null,
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v11/*: any*/),
      "type": "CustomerRate",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v13 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "targetId"
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appliesToMembershipType",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "duration",
      "variableName": "durationMins"
    },
    {
      "kind": "Variable",
      "name": "playerCount",
      "variableName": "playerCount"
    }
  ],
  "kind": "ScalarField",
  "name": "totalDurationPrice",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "holeCount",
      "variableName": "holeCount"
    }
  ],
  "kind": "ScalarField",
  "name": "totalGolfPrice",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "sourceBookingRateId"
    }
  ],
  "concreteType": "SlotRate",
  "kind": "LinkedField",
  "name": "slotRate",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v17/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "rate",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v21 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "slotTargetId"
  }
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "rate",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v10/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PatronBookingAffectedRateItemLineQuery",
    "selections": [
      (v12/*: any*/),
      {
        "alias": "sourceRoundOrBooking",
        "args": (v13/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "rate",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "startSlot",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "StandardBooking",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "player",
                "plural": false,
                "selections": [
                  (v19/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RoundRate",
                "kind": "LinkedField",
                "name": "roundRate",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v16/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Round",
            "abstractKey": "__isRound"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "targetSlotForBookingPrice",
        "args": (v21/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "SlotRate",
                "kind": "LinkedField",
                "name": "slotRate",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "TimeSlot",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "PatronBookingAffectedRateItemLineQuery",
    "selections": [
      (v12/*: any*/),
      {
        "alias": "sourceRoundOrBooking",
        "args": (v13/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "rate",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v10/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "startSlot",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "StandardBooking",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "player",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v19/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RoundRate",
                "kind": "LinkedField",
                "name": "roundRate",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v16/*: any*/),
                  (v22/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Round",
            "abstractKey": "__isRound"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "targetSlotForBookingPrice",
        "args": (v21/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "SlotRate",
                "kind": "LinkedField",
                "name": "slotRate",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "TimeSlot",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f12d0ac63c495fee628139ec7e1588a0",
    "id": null,
    "metadata": {},
    "name": "PatronBookingAffectedRateItemLineQuery",
    "operationKind": "query",
    "text": "query PatronBookingAffectedRateItemLineQuery(\n  $rateId: ID!\n  $targetId: ID!\n  $durationMins: Int!\n  $playerCount: Int!\n  $holeCount: HoleCount!\n  $slotTargetId: ID!\n  $sourceBookingRateId: ID!\n) {\n  newRate: node(id: $rateId) {\n    __typename\n    id\n    ... on CustomerRate {\n      name\n    }\n  }\n  sourceRoundOrBooking: node(id: $targetId) {\n    __typename\n    ... on StandardBooking {\n      id\n      rate {\n        __typename\n        name\n        code\n        appliesToMembershipType\n        id\n      }\n      startSlot {\n        __typename\n        id\n        slotRate(id: $sourceBookingRateId) {\n          totalDurationPrice(duration: $durationMins, playerCount: $playerCount)\n          totalGolfPrice(holeCount: $holeCount)\n        }\n      }\n    }\n    id\n    ... on Round {\n      __isRound: __typename\n      player {\n        __typename\n        fullName\n        id\n      }\n      roundRate {\n        totalGolfPrice(holeCount: $holeCount)\n        totalDurationPrice(duration: $durationMins, playerCount: $playerCount)\n        rate {\n          __typename\n          name\n          id\n        }\n      }\n    }\n  }\n  targetSlotForBookingPrice: node(id: $slotTargetId) {\n    __typename\n    ... on TimeSlot {\n      id\n      slotRate(id: $rateId) {\n        rate {\n          __typename\n          name\n          id\n        }\n        totalDurationPrice(duration: $durationMins, playerCount: $playerCount)\n        totalGolfPrice(holeCount: $holeCount)\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b82d80f3c9b68e2be10a3922393b32d9";

export default node;
